module.exports = __webpack_public_path__ + "static/media/flapp_bird.3f26afe9.png";